import React, { useEffect, useState } from 'react';
import CalendarSelector from './CalendarSelector';

const isAttendanceCountPublic = (event) => Boolean(Number(event?.attendance_count_public));

const SwitchAttendanceCountVisibility = ({ event, socket }) => {
    const [selectedVisibility, setSelectedVisibility] = useState(isAttendanceCountPublic(event));

    useEffect(() => {
        setSelectedVisibility(isAttendanceCountPublic(event));
    }, [event]);

    const changeVisibility = (isPublic) => {
        setSelectedVisibility(isPublic);
        socket.emit('.change_event_attendance_count_public', event.hash, isPublic);
    };

    const options = [
        { value: false, label: 'Privat' },
        { value: true, label: 'Públic' },
    ];

    return (
        <CalendarSelector
            label="Assistència"
            options={options}
            selectedValues={selectedVisibility}
            onSelect={changeVisibility}
        />
    );
};

export default SwitchAttendanceCountVisibility;
